import { render, staticRenderFns } from "./OrderCommodities.vue?vue&type=template&id=d3a428a2"
import script from "./OrderCommodities.vue?vue&type=script&lang=ts"
export * from "./OrderCommodities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports